var _style, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _g, _path, _g2, _g3, _circle4, _circle5, _circle6, _path2, _path3, _circle7, _path4, _path5, _path6, _circle8, _path7, _circle9, _path8, _circle10, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14, _path15, _path16, _polygon, _path17, _polygon2, _path18, _path19, _circle11, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#F54922;}\n\t.st3{fill:#3F3D56;}\n\t.st4{fill:#FFB8B8;}\n\t.st5{fill:#2F2E41;}\n\t.st6{fill:#A0616A;}\n\t.st7{fill:#CCCCCC;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "b8f08c5c-b476-40dd-b664-770adaae3509",
    className: "st0",
    cx: 96.3,
    cy: 135.3,
    r: 2.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "eee44b09-a27a-4be3-8c5b-6b6370df12ff",
    className: "st0",
    cx: 106.3,
    cy: 135.3,
    r: 2.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "a2d5f093-6500-400f-8de1-66712a079cc1",
    className: "st0",
    cx: 116.3,
    cy: 135.3,
    r: 2.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "e14e0169-ef8c-4de3-8e3e-1fb1636d9038",
    x: 89.9,
    y: 141.5,
    className: "st0",
    width: 334.4,
    height: 1.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "ffd44901-e4e1-4980-b03e-373b3661f4a7",
    x: 40.2,
    y: 101.6,
    className: "st1",
    width: 384.4,
    height: 246.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "e89f9aca-511f-49ec-bc12-8613d3bd0166",
    x: 40,
    y: 101.4,
    className: "st2",
    width: 384.4,
    height: 16.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "ad9dc5de-4949-4eac-9eb5-22ff577a9f6a",
    x: 51.5,
    y: 130.9,
    className: "st0",
    width: 362.5,
    height: 93.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "b859c105-7eee-4028-bc04-8285f6faca7e",
    x: 51.7,
    y: 240.2,
    className: "st0",
    width: 362.5,
    height: 93.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa41527c-9c03-4708-86c5-0d027f971362"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "b2d77c21-275f-42a7-94e0-5b816ba20a4e",
    x: 173.9,
    y: 151.7,
    className: "st1",
    width: 196.2,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b25a2924-64e6-4438-87d6-1fb43933af96",
    x: 173.9,
    y: 173.6,
    className: "st1",
    width: 69.9,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b8fe27c9-e561-42fa-9287-e7ff86698f34",
    x: 173.9,
    y: 195.4,
    className: "st1",
    width: 139.3,
    height: 8.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a368706a-11d6-41a2-bd00-6a6054248d43-974",
    className: "st2",
    d: "M159.1,286.7c0,6.4-1.8,12.6-5.3,17.9c-0.7,1.1-1.5,2.2-2.4,3.2 c-2,2.4-4.4,4.5-7,6.2c-0.7,0.5-1.4,0.9-2.2,1.3c-3.9,2.2-8.3,3.5-12.7,3.9c-1,0.1-2,0.1-3.1,0.1c-2.9,0-5.7-0.4-8.5-1.1 c-1.6-0.4-3.1-0.9-4.6-1.6c-0.8-0.3-1.5-0.7-2.2-1.1c-1.7-0.9-3.4-2-4.9-3.2c-0.7-0.6-1.4-1.1-2.1-1.8c-13.3-12.3-14.1-33-1.8-46.3 c12.3-13.3,33-14.1,46.3-1.8C155.3,268.8,159.1,277.5,159.1,286.7L159.1,286.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a0fe7a2e-49bf-4761-b17e-3d52136366c5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "a077c903-9ff8-47f6-8a24-46120c36a494",
    x: 124.3,
    y: 271.4,
    className: "st0",
    width: 4,
    height: 30.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a4f09271-2c50-4e11-a9a3-c26018ed4477",
    x: 111,
    y: 284.7,
    className: "st0",
    width: 30.6,
    height: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "bd7f0843-9709-4a5c-8b0e-26656563f0b3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "e4567469-258f-4b3a-88b2-7a234fbc5498",
    x: 169,
    y: 261,
    className: "st1",
    width: 196.2,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b26a9710-740f-4201-9a9a-df254658921a",
    x: 169,
    y: 282.8,
    className: "st1",
    width: 69.9,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a1758efc-04f7-4da1-846b-fd169401f4c2",
    x: 169,
    y: 304.7,
    className: "st1",
    width: 139.3,
    height: 8.7
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "f2fdcd7e-077f-47c5-987d-3f56ec08fcb2",
    className: "st0",
    cx: 65.4,
    cy: 109.6,
    r: 2.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "bb8af87f-8865-4134-a554-08faac1a89d0",
    className: "st0",
    cx: 75.7,
    cy: 109.6,
    r: 2.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "bd4c0ca0-b96c-4f92-a965-84f83cdee98a",
    className: "st0",
    cx: 55.1,
    cy: 109.6,
    r: 2.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146,204.2c-2.9-1.5-5.9-2.8-8.9-3.8l-0.4-4.3l-15.9-1.7l-2,5.6l-5.7,2.1c-0.2,0.1-0.4,0.2-0.6,0.3h0 c-0.6,0.4-1.1,1.1-1.2,1.9c-0.1,0.4,0,0.8,0,1.1l0.3,1.2c0.4,0.3,0.9,0.5,1.3,0.7l0.3,0.1c0.7,0.3,1.3,0.7,2,1 c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0,0,0,0c0.3,0.1,0.6,0.3,1,0.4c1.1,0.4,2.2,0.8,3.3,1.1c2.8,0.8,5.8,1.1,8.7,1.1c1.1,0,2.1,0,3.2-0.2 c2.4-0.2,4.8-0.7,7-1.4c0,0,0,0,0,0c1.4-0.5,2.9-1,4.2-1.7c0,0,0,0,0,0c0.3-0.1,0.6-0.3,0.9-0.5l0.1-0.1c0.2-0.1,0.5-0.3,0.7-0.4 c0.6-0.3,1.2-0.7,1.8-1.1c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.2,0.5-0.3,0.7-0.5C147.2,204.9,146.6,204.6,146,204.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.1,206.9l-1-4.5h-2.6c0,0-0.1,0-0.1,0h0c-0.9,0.1-1.8,0.4-2.6,0.9c-0.5,0.3-1,0.8-1.4,1.3 c0.8,0.6,1.6,1.1,2.4,1.7l0,0c0.2,0.1,0.5,0.3,0.7,0.4c0.4,0.3,0.9,0.5,1.3,0.7l0.3,0.1c0.7,0.3,1.3,0.7,2,1 c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0,0,0,0c0.3,0.1,0.6,0.3,1,0.4L116.1,206.9z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 128.1,
    cy: 180.2,
    r: 11.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.3,174.6c1.2,1.4,3.2,1.8,5.1,2c4.3,0.2,8.7-0.1,12.9-1.1c0.3,2.5-0.5,5.3,1,7.4c0.7-2.5,1.1-5.1,1.2-7.8 c0.1-1.1,0-2.3-0.4-3.3c-0.4-1.1-1.4-1.8-2.6-1.9c0.9-0.6,1.9-1.1,2.9-1.2l-3.6-1.8l0.9-1l-6.6-0.4l1.9-1.2 c-2.9-0.4-5.8-0.5-8.7-0.3c-1.3,0.1-2.8,0.3-3.8,1.1c-1.1,0.8-1.7,2.3-1,3.5c-1.7,0.3-3.2,1.4-3.8,3c-0.4,1.3-0.5,2.6-0.3,3.9 c0.2,2.1,0.7,4.2,1.5,6.2L120.3,174.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.3,167.7c-6.1-17.6-25.3-26.9-42.9-20.7c-17.6,6.1-26.9,25.3-20.7,42.9c1.2,3.6,3.1,6.9,5.4,9.9 c0.3,0.4,0.6,0.8,0.9,1.1c0,0,0,0,0.1,0.1c0.8,0.9,1.6,1.8,2.5,2.6c0.2,0.2,0.5,0.4,0.7,0.6c0.5,0.4,0.9,0.8,1.4,1.2 c0.2,0.2,0.4,0.3,0.6,0.4c0.8,0.6,1.6,1.1,2.4,1.7l0,0c0.2,0.1,0.5,0.3,0.7,0.4c0.4,0.3,0.9,0.5,1.3,0.7l0.3,0.1 c0.7,0.3,1.3,0.7,2,1c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0,0,0,0c0.3,0.1,0.6,0.3,1,0.4c1.1,0.4,2.2,0.8,3.3,1.1c2.8,0.8,5.8,1.1,8.7,1.1 c1.1,0,2.1,0,3.2-0.2c2.4-0.2,4.8-0.7,7-1.4c0,0,0,0,0,0c1.4-0.5,2.9-1,4.2-1.7c0,0,0,0,0,0c0.3-0.1,0.6-0.3,0.9-0.5l0.1-0.1 c0.2-0.1,0.5-0.3,0.7-0.4c0.6-0.3,1.2-0.7,1.8-1.1c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.2,0.5-0.3,0.7-0.5c0.3-0.2,0.6-0.4,0.9-0.6 c0.1-0.1,0.2-0.1,0.3-0.2C160.5,196.8,165.1,181.5,160.3,167.7L160.3,167.7z M147.8,204.2c-0.2,0.2-0.4,0.3-0.6,0.4 c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.2-0.5,0.4l-0.1,0c-0.1,0.1-0.3,0.2-0.4,0.3c-0.5,0.3-1,0.6-1.5,0.9 c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.5,0.2-0.7,0.4c0,0-0.1,0-0.1,0l0,0c-0.3,0.2-0.6,0.3-0.9,0.4c-1.1,0.6-2.3,1-3.5,1.4 c-0.2,0.1-0.3,0.1-0.5,0.2c-2.2,0.7-4.4,1.1-6.7,1.4c-1,0.1-2,0.1-3,0.1c-2.8,0-5.5-0.4-8.2-1.1c-1.4-0.4-2.7-0.8-4-1.4 c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.6-0.2-1.1-0.5-1.7-0.8l-0.3-0.1c-0.7-0.4-1.3-0.7-2-1.1 c-0.2-0.1-0.4-0.2-0.6-0.4c0,0-0.1-0.1-0.1-0.1c-0.4-0.3-0.9-0.6-1.3-0.9c-0.3-0.2-0.6-0.4-0.8-0.6c-0.5-0.4-0.9-0.7-1.3-1.1 c-0.2-0.2-0.5-0.4-0.7-0.6c-0.9-0.8-1.7-1.6-2.4-2.5c-0.3-0.3-0.5-0.6-0.7-0.9c-0.1-0.1-0.1-0.1-0.2-0.2 c-10.9-13.8-8.6-33.8,5.2-44.7s33.8-8.6,44.7,5.2s8.6,33.8-5.2,44.7C148.1,203.9,148,204,147.8,204.2L147.8,204.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.1,304.4c-6.1-17.6-25.3-26.9-42.9-20.7c-17.6,6.1-26.9,25.3-20.7,42.9c1.2,3.6,3.1,6.9,5.4,9.9 c0.3,0.4,0.6,0.8,0.9,1.1c0,0,0,0,0.1,0.1c0.8,0.9,1.6,1.8,2.5,2.6c0.2,0.2,0.5,0.4,0.7,0.6c0.5,0.4,0.9,0.8,1.4,1.2 c1,0.8,2,1.5,3,2.1l0,0c0.7,0.4,1.4,0.8,2.1,1.2l0.3,0.1c0.7,0.3,1.3,0.7,2,1c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0,0,0,0 c1.4,0.6,2.8,1.1,4.2,1.4c2.8,0.8,5.8,1.1,8.7,1.1c1.1,0,2.1,0,3.2-0.2c2.4-0.2,4.8-0.7,7-1.4c0,0,0,0,0,0c1.4-0.5,2.9-1,4.2-1.7 c0,0,0,0,0,0c0.3-0.1,0.6-0.3,0.9-0.5l0.1-0.1c0.2-0.1,0.5-0.3,0.7-0.4c0.6-0.3,1.2-0.7,1.8-1.1c0.2-0.1,0.3-0.2,0.5-0.3 c0.5-0.4,1.1-0.7,1.6-1.1c0.1-0.1,0.2-0.1,0.3-0.2C407.3,333.5,411.9,318.2,407.1,304.4L407.1,304.4z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "ee9bd31a-9b73-4888-9087-fea26d3b2b97",
    className: "st5",
    cx: 386.4,
    cy: 324.3,
    r: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "e473f415-6540-4896-b89f-76a5ac7ad60a-975",
    className: "st5",
    d: "M387.8,319.4c2.8,0,5.1,2.3,5.1,5.1c0,0.8-0.2,1.7-0.6,2.4 c1.7-2.2,1.4-5.4-0.8-7.1c-2.2-1.7-5.4-1.4-7.1,0.8c-0.2,0.2-0.4,0.5-0.5,0.8C384.8,320.1,386.3,319.4,387.8,319.4L387.8,319.4z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "f79ae9d5-f4b5-4dd5-badc-cc4d2f5593dd",
    className: "st5",
    cx: 377,
    cy: 309.5,
    r: 14.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "f9880a76-ad0b-4c2a-99b0-b23c20a810bd-976",
    className: "st5",
    d: "M365.3,300.3c5.3-6,14.4-6.7,20.6-1.6c-0.1-0.1-0.2-0.2-0.4-0.3 c-6.1-5.5-15.5-5-20.9,1.2c-5.5,6.1-5,15.5,1.2,20.9l0,0c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.3,0.2,0.4,0.3 C360.4,315.4,360,306.3,365.3,300.3L365.3,300.3z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "b01904a1-9532-4133-8cbd-470829617487",
    className: "st6",
    cx: 376.8,
    cy: 314.7,
    r: 9.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M393.9,339.5v3.2c-0.6,0.4-1.2,0.7-1.8,1.1c-0.2,0.1-0.5,0.3-0.7,0.4l-0.1,0.1c-0.3,0.2-0.6,0.3-0.9,0.5 c0,0,0,0,0,0c-1.4,0.7-2.8,1.2-4.2,1.7c0,0,0,0,0,0c-2.3,0.7-4.6,1.2-7,1.4c-1,0.1-2.1,0.2-3.2,0.2c-2.9,0-5.9-0.4-8.7-1.1 c-1.4-0.4-2.9-0.9-4.2-1.4c0,0,0,0,0,0c-0.1-0.1-0.3-0.1-0.4-0.2c-0.7-0.3-1.3-0.6-2-1l-0.3-0.1c-0.7-0.4-1.4-0.8-2.1-1.2l0,0 c-1-0.6-2-1.3-3-2.1c-0.5-0.4-1-0.8-1.4-1.2c-0.2-0.2-0.5-0.4-0.7-0.6c-0.9-0.8-1.7-1.7-2.5-2.6c0.1-0.6,0.3-1.3,0.5-1.9l0,0 c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c1.1-2,3-2.5,5.5-2.6c1.4-0.1,2.9,0,4.5,0c0.8,0,1.7,0,2.6-0.1 c5.5-0.5,4.5-3.8,4.8-5.5c0.2-1.7,1.8-0.2,1.9-0.1l0,0c3.1,1.5,6.6,2.1,10,1.8c0.6-0.1,1.2-0.1,1.8-0.1c1.6,0,1.2,0.4,0.7,0.8 c-0.3,0.2-0.5,0.3-0.8,0.5c0,0-0.2,1.5-0.5,3.8c-0.2,2.2,3.9,3.2,4.3,3.3c0,0,0,0,0,0c1.5-0.4,3.1-0.4,4.6,0.1h0 C392.2,336.3,393.5,337.7,393.9,339.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363,343.4c0,0.4,0,0.9,0,1.3c0,0.2,0,0.5,0,0.7c0,0,0,0,0,0c-0.1-0.1-0.3-0.1-0.4-0.2c-0.7-0.3-1.3-0.6-2-1 l-0.3-0.1c-0.7-0.4-1.4-0.8-2.1-1.2c0-0.2,0-0.4,0.1-0.6c0.1-0.5,0.1-0.9,0.2-1.4c0.2-3.3-0.4-6.6-1.7-9.5v0 c-0.1-0.2-0.2-0.4-0.2-0.4s1.8-1.5,4.3,0c0.2,0.1,0.3,0.2,0.4,0.4C362.7,333.1,363.1,339.1,363,343.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M390.5,342.6c0,0.7-0.1,1.4-0.1,2.1v0c0,0,0,0,0,0c-1.4,0.7-2.8,1.2-4.2,1.7c0,0,0,0,0,0l-0.1-1.7l0-0.2 l-0.3-8.3c0-0.8,0.6-1.4,1.3-1.5c0,0,0,0,0.1,0h3.1c0.2,0,0.3,0.3,0.3,0.9v0C390.6,338,390.6,340.3,390.5,342.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "a05c59bd-0311-408b-a800-ed606f18fbbf-977",
    className: "st5",
    d: "M368.7,302.7v9.6h2.2l2.8-3l-0.4,3h9.8l-0.6-3l1.2,3h1.6v-9.6 H368.7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "af122121-1c1b-4817-a566-2298b147ce18",
    className: "st6",
    cx: 367.1,
    cy: 312.6,
    rx: 0.8,
    ry: 1.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "bec83a12-853e-4dd5-94d0-e2c2a5b21156",
    className: "st6",
    cx: 386.5,
    cy: 312.6,
    rx: 0.8,
    ry: 1.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396,341.3c-0.5,0.4-1,0.8-1.6,1.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.6,0.4-1.2,0.7-1.8,1.1 c-0.2,0.1-0.5,0.3-0.7,0.4v-6.7c0,0,1,0.8,2.5,2.1c0.2,0.2,0.4,0.3,0.6,0.5C395,340.5,395.5,340.9,396,341.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M407.1,304.4c-6.1-17.6-25.3-26.9-42.9-20.7c-17.6,6.1-26.9,25.3-20.7,42.9c1.2,3.6,3.1,6.9,5.4,9.9 c0.3,0.4,0.6,0.8,0.9,1.1c0,0,0,0,0.1,0.1c0.8,0.9,1.6,1.8,2.5,2.6c0.2,0.2,0.5,0.4,0.7,0.6c0.5,0.4,0.9,0.8,1.4,1.2 c1,0.8,2,1.5,3,2.1l0,0c0.7,0.4,1.4,0.8,2.1,1.2l0.3,0.1c0.7,0.3,1.3,0.7,2,1c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0,0,0,0 c1.4,0.6,2.8,1.1,4.2,1.4c2.8,0.8,5.8,1.1,8.7,1.1c1.1,0,2.1,0,3.2-0.2c2.4-0.2,4.8-0.7,7-1.4c0,0,0,0,0,0c1.4-0.5,2.9-1,4.2-1.7 c0,0,0,0,0,0c0.3-0.1,0.6-0.3,0.9-0.5l0.1-0.1c0.2-0.1,0.5-0.3,0.7-0.4c0.6-0.3,1.2-0.7,1.8-1.1c0.2-0.1,0.3-0.2,0.5-0.3 c0.5-0.4,1.1-0.7,1.6-1.1c0.1-0.1,0.2-0.1,0.3-0.2C407.3,333.5,411.9,318.2,407.1,304.4L407.1,304.4z M394.5,340.9 c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.1-0.3,0.2-0.5,0.3c-0.5,0.3-1,0.6-1.5,0.9 c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.5,0.2-0.7,0.4c0,0-0.1,0-0.1,0l0,0c-0.3,0.2-0.6,0.3-0.9,0.4c-1.1,0.6-2.3,1-3.5,1.4 c-0.2,0.1-0.3,0.1-0.5,0.2c-2.2,0.7-4.4,1.1-6.7,1.4c-1,0.1-2,0.1-3,0.1c-2.8,0-5.5-0.4-8.2-1.1c-1.4-0.4-2.7-0.8-4-1.4 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.6-0.2-1.1-0.5-1.7-0.8l-0.3-0.1c-0.7-0.4-1.3-0.7-2-1.1 c-0.2-0.1-0.5-0.3-0.7-0.5c-0.7-0.5-1.4-1-2.1-1.5c-0.5-0.4-0.9-0.7-1.3-1.1c-0.2-0.2-0.5-0.4-0.7-0.6c-0.9-0.8-1.7-1.6-2.4-2.5 c-0.3-0.3-0.5-0.6-0.7-0.9c-0.1-0.1-0.1-0.1-0.2-0.2c-10.9-13.8-8.6-33.8,5.2-44.7c13.8-10.9,33.8-8.6,44.7,5.2 c10.9,13.8,8.6,33.8-5.2,44.7C394.9,340.6,394.7,340.7,394.5,340.9L394.5,340.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M405.2,301.8c3.2-1.1,4.8-4.6,3.6-7.8c-0.1-0.3-0.3-0.7-0.5-1l14.1-16.4l-11.1-1.4L399.7,291 c-2.8,1.9-3.6,5.7-1.7,8.5C399.6,301.8,402.5,302.8,405.2,301.8L405.2,301.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M484.8,305.2c2.2-2.5,2-6.4-0.6-8.6c-0.3-0.2-0.6-0.4-0.9-0.6l4.5-21.1l-10.5,4.1l-2.7,19.4 c-1.6,3-0.4,6.7,2.6,8.2C479.9,308,483,307.4,484.8,305.2L484.8,305.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "434.2,415.4 426.8,415.4 423.3,386.8 434.2,386.8 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M436.1,422.6l-23.9,0v-0.3c0-5.1,4.2-9.3,9.3-9.3c0,0,0,0,0,0h0l14.6,0L436.1,422.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "470.5,415.4 463.1,415.4 459.6,386.8 470.5,386.8 "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M472.4,422.6l-23.9,0v-0.3c0-5.1,4.2-9.3,9.3-9.3c0,0,0,0,0,0h0l14.6,0L472.4,422.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M435,400.5l-10.5-0.4c-1.5-0.1-2.7-1.3-2.6-2.8l3-97l0.2-0.1c18.4-6.7,33.6-6.2,46.5,1.5l0.1,0.1l1.8,94.5 c0,1.5-1.2,2.7-2.7,2.8c0,0,0,0-0.1,0h-8.9c-1.3,0-2.4-0.9-2.7-2.2l-12.1-61.3c-0.1-0.5-0.6-0.8-1.1-0.7c-0.4,0.1-0.7,0.4-0.7,0.8 l-7.6,62.5c-0.2,1.4-1.3,2.4-2.7,2.4C435.1,400.5,435,400.5,435,400.5z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 445.2,
    cy: 200.3,
    r: 14.9
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M410.2,290c-0.5-0.2-1-0.6-1.3-1l-2.9-4.3c-0.6-1-0.6-2.2,0.1-3.1l11.6-15.7l7.2-34.8c1.8-4.5,6.8-6.7,11.4-5 c4.5,1.8,6.7,6.8,5,11.4l0,0l-3.4,22.1c-1,6.7-4.5,12.8-9.7,17.2L413,289.5c-0.6,0.5-1.4,0.7-2.1,0.6 C410.6,290.1,410.4,290.1,410.2,290z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M484.2,291.6c-0.5,0.2-1.1,0.2-1.6,0.1l-5-1.3c-1.1-0.3-1.9-1.3-2-2.4l-1.7-19.4l-17.5-30.9 c-1.7-4.5,0.7-9.6,5.2-11.3c4.5-1.7,9.6,0.7,11.3,5.2c0,0,0,0,0,0l12.1,18.9c3.7,5.7,5.1,12.6,4.1,19.3l-3,19.7 c-0.1,0.8-0.6,1.4-1.2,1.9C484.6,291.4,484.4,291.5,484.2,291.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M429,226.7c5.2-5.7,12.6-8.7,20.3-8.2c0.2,0,0.5,0,0.7,0.1h0c7.2,0.6,13.9,4.2,18.2,10.1 c4.4,5.9,6.1,13.4,4.6,20.7c-2.9,13.6-2.2,27.8,2.1,41.1l4,12.4c0.5,1.4-0.3,3-1.8,3.4c-0.2,0.1-0.5,0.1-0.7,0.1l-20.4,1.1l-5.2-9 v9.3l-24.8,1.3c0,0-0.1,0-0.1,0c-1.5,0-2.7-1.2-2.7-2.7c0-0.1,0-0.1,0-0.2l2.8-34.7l-3.5-23.6C421.4,240.1,423.7,232.4,429,226.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M455.5,214.5c-1.4,0.8-6.8,1.3-7.2-0.2l0,0c-0.3-1.1,0-2.3,0-3.5c0.1-1.2,0-2.4-0.8-3.3 c-1.5-1.6-4.1-0.7-6.2-1.1c-2.6-0.6-4.3-3-4.1-5.6c0-0.2,0.1-0.5,0.1-0.7c0.5-2.2-0.9-4.3-3.1-4.8c-0.4-0.1-0.7-0.1-1.1-0.1 c-2.1,0.1-4.5,0.8-6.2-0.8c-1.4-1.2-1.7-4.4-1.1-6.2c1-2.9,7.5-4.5,10.3-5.3c7.1-2.1,14.8-0.8,20.8,3.4c1.8,1.3,3.5,2.8,4.2,4.9 c0.8,2.1,0.4,4.6-1.3,6c2.7,2.9,3.7,7,2.6,10.8C461.6,210.7,457.6,213.4,455.5,214.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M499.4,423.6H370.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h128.8c0.3,0,0.6,0.3,0.6,0.6 C500,423.3,499.7,423.6,499.4,423.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAction);
export default __webpack_public_path__ + "static/media/createAction.67519507b67a800a95c90f8cdd2610b5.svg";
export { ForwardRef as ReactComponent };